/* src/app/system-utils/generic-icon/generic-icon.component.scss */
/*# sourceMappingURL=generic-icon.component.css.map */
